<div class="gallery">
  <!-- Main image -->
  <div
    class="gallery__main"
    [class.gallery__main--single]="isSingle()"
    [attr.data-variant]="variant()"
    data-zoom-container
    (touchstart)="onTouchStart($event)"
    (touchend)="onTouchEnd($event)"
  >
    <!-- Badge slot -->
    <div class="gallery__badges">
      <ng-content select="[gallery-badges]" />
    </div>

    @if (hasDoubleFace() && backImageUrl()) {
      <!-- Double-face card with flip -->
      <div
        class="gallery__flip-container"
        [class.gallery__flip-container--flipped]="isFlipped()"
        role="button"
        tabindex="0"
        [attr.aria-label]="'Voltear ' + productName()"
        (click)="onImageClick()"
        (keydown.enter)="onImageClick(); $event.preventDefault()"
        (keydown.space)="onImageClick(); $event.preventDefault()"
      >
        <img
          class="gallery__image gallery__face gallery__face--front"
          [src]="selectedImage()"
          [alt]="productName()"
          loading="lazy"
        />
        <img
          class="gallery__image gallery__face gallery__face--back"
          [src]="backImageUrl()!"
          [alt]="productName() + ' — reverso'"
          loading="lazy"
        />
      </div>
    } @else {
      <!-- Single-face card -->
      <img
        class="gallery__image"
        [src]="selectedImage()"
        [alt]="productName()"
        loading="lazy"
        appInnerZoom
        (click)="onImageClick()"
      />
    }

    <!-- Action buttons for double-face cards -->
    @if (hasDoubleFace() && backImageUrl()) {
      <button
        class="gallery__flip-btn gallery__zoom-btn"
        type="button"
        (click)="onZoomClick(); $event.stopPropagation()"
        aria-label="Ampliar imagen"
      >
        <app-icon [icon]="zoomIcon" [size]="18" />
        <span>Zoom</span>
      </button>
      <button
        class="gallery__flip-btn"
        type="button"
        (click)="toggleFlip(); $event.stopPropagation()"
        aria-label="Voltear carta"
      >
        <app-icon [icon]="rotateIcon" [size]="18" />
        <span>Voltear</span>
      </button>
    }
  </div>

  <!-- Thumbnail strip -->
  @if (hasMultipleImages()) {
    <div class="gallery__thumbs" #thumbStrip>
      @for (img of images(); track $index) {
        <button
          class="gallery__thumb"
          [class.gallery__thumb--active]="$index === selectedIndex()"
          type="button"
          (click)="selectImage($index)"
          [attr.aria-label]="'Ver imagen ' + ($index + 1)"
        >
          <img
            class="gallery__thumb-img"
            [src]="img"
            [alt]="productName() + ' — miniatura ' + ($index + 1)"
            loading="lazy"
          />
        </button>
      }
    </div>
  }
</div>
